import { MessageBox } from '@qs/ui'
import Vue from 'vue'
import purchaseDialog from '@/pages/organize/eSign/purchaseDialog/index.vue'


/**
 * 自定义MessageBox hooks
 */
export function useMessageBox() {
  const mountPurchaseDialog = (licenceNo) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    // 获取当前应用的根实例，确保继承所有全局配置
    const rootInstance = document.querySelector('#app').__vue__

    const PurchaseDialogCtor = Vue.extend(purchaseDialog)
    const instance = new PurchaseDialogCtor({
      parent: rootInstance, // 设置父实例，继承全局配置
      propsData: {
        licenceNo,
      },
      // 确保继承 store、router 等全局依赖
      store: rootInstance.$store,
      router: rootInstance.$router,
    })

    instance.$mount(container)
    if (typeof instance.showDialog === 'function') {
      instance.showDialog()
    }
    return instance
  }
  /**
   * 显示E签宝份额不足的对话框
   * @param {Function} onConfirm - 确认回调函数
   * @param {Function} onCancel - 取消回调函数
   */
  const showESignQuotaDialog = (licenceNo) => {
    return MessageBox({
      title: 'E签宝份额不足',
      message: `
        <div style="text-align: center; padding: 20px 0;">
          <div style="display: flex; flex-direction: column; align-items: center;">
            <i class="el-icon-warning" style="color: #FF8C00; font-size: 36px;"></i>
            <h3 style="margin: 5px 0 8px 0; font-size: 16px; font-weight: 500; color: #333;">合同签署发起失败</h3>
            <p style="margin: 0; font-size: 14px; color: #666; line-height: 1.4;">E签宝份额不足，请购买后重新发起合同签约。</p>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: '购买份额',
      cancelButtonText: '取消',
      showClose: false,
      customClass: 'custom-esign-dialog',
      dangerouslyUseHTMLString: true,
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          mountPurchaseDialog(licenceNo)
          done()
        } else {
          done()
        }
      },
    })
  }

  return {
    showESignQuotaDialog,
  }
}
